import { useQuery } from 'react-query';
import { apiClient, endpoints } from '../api/client';

export interface SystemMetrics {
  cpu_usage: number;
  memory_usage: number;
  disk_usage: number;
  network_latency: number;
  database_connections: number;
  redis_memory_usage: string;
  active_tasks: number;
  queue_size: number;
}

export const useSystemMetrics = () => {
  return useQuery<SystemMetrics>(
    'systemMetrics',
    async () => {
      const response = await apiClient.get(endpoints.systemStatus + '/metrics');
      return response.data;
    },
    {
      refetchInterval: 60000,
      staleTime: 15000,
      cacheTime: 120000,
    }
  );
};
